/* eslint-disable jsx-a11y/label-has-for */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withIsActive from './withIsActive';

export default (WrappedComponent) => {
	const withDescription = class extends Component {
		render() {
			const { isActive, description, title, className, errorMessage, htmlFor, children } = this.props;
			const decriptionClassName = classNames('c-o-list-payment__labelled-by', {
				'c-o-list-payment__labelled-by--is-visible': !errorMessage && isActive && description,
			});
			const inputWrapClassName = classNames('c-o-list-payment__input-wrap', {
				'c-o-list-payment__input-wrap--has-error': !!errorMessage,
			});

			const errorMsgClassName = classNames('c-o-list-payment__error', {
				'c-o-list-payment__error--is-visible': !!errorMessage,
			});

			return (
				<div className={className} data-title={title}>
					<div className="c-o-list-payment__container">
						<label className="c-o-list-payment__row-label" htmlFor={htmlFor}>
							{title}
							{children}
						</label>

						<WrappedComponent {...this.props} inputWrapClassName={inputWrapClassName} />
						{description && <span className={decriptionClassName}>{description}</span>}
						{errorMessage && <span className={errorMsgClassName}>{errorMessage}</span>}
					</div>
				</div>
			);
		}
	};

	withDescription.displayName = `withDescription(${
		WrappedComponent.displayName || WrappedComponent.name || 'Component'
	})`;

	withDescription.propTypes = {
		isActive: PropTypes.bool.isRequired,
		description: PropTypes.string,
		title: PropTypes.string,
		id: PropTypes.string,
		className: PropTypes.string,
		errorMessage: PropTypes.string,
		htmlFor: PropTypes.string,
		children: PropTypes.node,
	};

	return withIsActive(withDescription);
};
